import { Documento } from "./documento.model";
import { BackendService, BackendModel } from "../core/backend.service";

export class Documentacion extends BackendModel {

  static path = 'documentacion-ordenada';
  id: number;
  description: string;
  documentos: Documento[];

  constructor(protected backendService: BackendService, model?: Documentacion) {
    super(backendService, model);
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/documentacion.model.ts